import React from "react";
import { connect } from "react-redux";
import { setAlert } from "../../action/alert";
import Alert from "../layout/Alert";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import { Box } from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CreateQRCode from "./createQRCode";
import FetchQRCode from "./fetchQRCode";
import QRCodeFilter from "./qrCodeCountFilter";

const activeTabSx = {
    border: '1px solid #bdbdbd',
    backgroundColor: '#e0e0e0',
    color: '#333333',
    textTransform: 'capitalize',
    minHeight: 48,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    textAlign: 'center'
};
const nonActiveTabSx = {
    border: 'none',
    backgroundColor: 'none',
    color: '#333333',
    textTransform: 'capitalize',
    minHeight: 48,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    textAlign: 'center'
};
const tabsRootSx = { minHeight: 0 };

const headers = {
    productSerialNumber: "Product Serial Number",
    status: "QR Code Print Status",
    reasonOfFailure: "Reason of Failure"
};

const QRCode = ({
    wrapperClass,
    allowedDeviceCategories,
    allowedCompanyBrand,
    setAlert
}) => {
    const [activeTab, setActiveTab] = React.useState(0)

    return (
        <ResponsiveContentWrapper className={wrapperClass || ""}>
            <Box className="row" sx={{ width: "100%", minWidth: 0 }}>
                <Tabs
                    value={activeTab}
                    onChange={(e, newValue) => {
                        setActiveTab(newValue)
                    }}
                    variant="scrollable"
                    scrollButtons="auto"
                    TabIndicatorProps={{
                        style: {
                            backgroundColor: "#bdbdbd"
                        }
                    }}
                    style={{ marginTop: 0 }}
                    sx={tabsRootSx}
                >
                    <Tab label="Create and Print QR Code" sx={activeTab == 0 ? activeTabSx : nonActiveTabSx} wrapped />
                    <Tab label="Fetch and Print QR Code" sx={activeTab == 1 ? activeTabSx : nonActiveTabSx} wrapped />
                    <Tab label="QR Code Count" sx={activeTab == 2 ? activeTabSx : nonActiveTabSx} wrapped />
                </Tabs>
                {activeTab === 0 && (
                    <CreateQRCode
                        allowedDeviceCategories={allowedDeviceCategories}
                        allowedCompanyBrand={allowedCompanyBrand}
                        setAlert={setAlert}
                    />
                )}
                {activeTab === 1 && (
                    <FetchQRCode
                        allowedDeviceCategories={allowedDeviceCategories}
                        allowedCompanyBrand={allowedCompanyBrand}
                        setAlert={setAlert}
                    />
                )}
                {activeTab === 2 && (
                    <QRCodeFilter
                        setAlert={setAlert}
                    />
                )}
            </Box>
        </ResponsiveContentWrapper>
    );
}

const mapStateToProps = (state) => ({
    allowedDeviceCategories: state.auth.allowedDeviceCategories,
    allowedCompanyBrand: state.auth.allowCompanyBrand,
});

const mapDispatchToProps = (dispatch) => ({
    setAlert: (message, status) => dispatch(setAlert(message, status))
});

export default connect(mapStateToProps, mapDispatchToProps)(QRCode);